import { HomeIcon, LocationIcon, ProgramsIcon } from '@repo/ui';
import { link } from 'astro-typed-links/link';
import { GraduationCap, InfoIcon, PlusIcon } from 'lucide-react';
import linkConfig from '../content/site-config/links.json';
export const SITE_INFO = {
  title: linkConfig.default.title,
  copyright: linkConfig.default.copyright,
  longTitle: linkConfig.default.longTitle,
};
type LinkRef = typeof linkConfig;

const findLinkRef = (slug: keyof LinkRef, defaultLabel: string) => {
  const linkRef = linkConfig[slug];
  if (!linkRef) {
    return { label: defaultLabel };
  }
  return { label: linkRef.title };
};

export const mainLinks = [
  { ...findLinkRef('home', 'Home'), url: link('/'), icon: HomeIcon },
  {
    ...findLinkRef('locations', 'Locations'),
    url: link('/locations'),
    icon: LocationIcon,
  },
  {
    ...findLinkRef('programs', 'Programs'),
    url: link('/programs'),
    icon: ProgramsIcon,
  },
  {
    ...findLinkRef('disciplines', 'Disciplines'),
    url: link('/disciplines'),
    icon: GraduationCap,
  },
  { ...findLinkRef('about', 'About'), url: link('/about'), icon: InfoIcon },
  {
    label: 'Add Program',
    icon: PlusIcon,
    footer: true,
    url: 'https://docs.google.com/forms/d/e/1FAIpQLSdkvgDORXKeEiPs0kvhnPKs5eLnOvfp3sMqdDgnhy0xTwveQw/viewform',
  },
  {
    label: 'Contact',
    url: 'mailto:contact-project+alexwine36-nm-stem-services-62915309-issue-@incoming.gitlab.com',
  },
];

export const MAIN_LINKS = mainLinks.map((item) => {
  let isExternal = false;

  if (item.url.startsWith('http')) {
    isExternal = true;
  }
  return {
    ...item,
    props: {
      ...(isExternal ? { target: '_blank' } : {}),
    },
  };
});

export const HeaderLinks = MAIN_LINKS.filter((item) => !item.footer);
export const FooterLinks = MAIN_LINKS.filter((item) => item.footer);

export const ADD_PROGRAM_LINK = MAIN_LINKS.find(
  (item) => item.label === 'Add Program'
);
